<template>
  <div>
    <el-dialog :visible.sync="showSetDomain">
      <el-form :model="dataSet">
        <el-form-item label="群号" style="text-align:left;"><el-input v-model="dataSet.chat_room" size="mini" style="width: 400px; " :disabled="room_disabled"></el-input></el-form-item>
        <el-form-item label="机器人号" style="text-align:left;"><el-input v-model="dataSet.wechat_id" size="mini" style="width: 400px; "  :disabled="room_disabled"></el-input></el-form-item>
        <el-form-item label="代理人ID" style="text-align:left;"><el-input v-model.number="dataSet.agent_id" size="mini" style="width: 200px;"  :disabled="room_disabled"></el-input></el-form-item>
        <el-form-item label="机器人微信昵称" style="text-align:left;"><el-input v-model.number="dataSet.nickname" size="mini" style="width: 200px;"></el-input></el-form-item>
        <el-form-item label="频道(channel)" style="text-align:left;"><el-input v-model.number="dataSet.channel" size="mini" style="width: 200px;"></el-input></el-form-item>
        <el-form-item label="品牌(brand)" style="text-align:left;"><el-input v-model.number="dataSet.brand" size="mini" style="width: 200px;"></el-input></el-form-item>
        <el-form-item label="状态" style="text-align:left;">
          <el-select v-model="dataSet.valid" label="状态">
            <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="success" size="mini" @click="subDomain()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-button size="mini"  type="primary"  @click="showDiv()">添加</el-button>

    <el-table :data="domainList" v-loading="loading">
      <el-table-column prop="id" label="ID" />
      <el-table-column prop="chat_room" label="群号" width="250px" />
      <el-table-column prop="wechat_id" label="机器人号" width="250px"  />
      <el-table-column prop="agent_id" label="代理人ID" />
      <el-table-column prop="user_id" width="50px">
        <template slot-scope="s">
          <el-image :src="s.row.agent_avatar || ''" style="width: 40px; height: 40px;"/>
        </template>
      </el-table-column>
      <el-table-column prop="agent_nickname" label="代理人微信昵称" />
      <el-table-column prop="nickname" label="机器人微信昵称" />
      <el-table-column prop="channel" label="频道(channel)" />
      <el-table-column prop="brand" label="品牌(brand)" />
      <el-table-column prop="valid"  label="状态" :formatter="function(r, c, v, i) { return v ? '开' : '关' }" />
      <el-table-column prop="id" label="操作" width="180px">
        <template slot-scope="scope">
          <el-button type="info" size="mini" @click="handleUser(scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <page-bar :currentPageCount="domainList.length" @page-changed="loadData"></page-bar> -->
  </div>
</template>

<script>
    import request from "../../api/request";

    export default {
        name: "ChatRoomList",
        data() {
            return {
                loading: true,
                showSetDomain: false,
                domainList:[],
                dataSet:{
                    chat_room:'',
                    wechat_id:'',
                    agent_id:'',
                    valid:'',
                    nickname:'',
                    channel:'',
                    brand:'',
                },
                searchData: {},
                filter: {},
                room_disabled: false,
                options: [
                    {
                        value: 0,
                        label: "关"
                    },
                    {
                        value: 1,
                        label: "开"
                    }
                ],
            };
        },
        created() {
            this.loadData();
        },
        methods: {
            subDomain: function() {
//      console.log(this.dataSet.user_id);

                request.tools
                    .post("chat_room_set", {
                        chat_room: this.dataSet.chat_room,
                        wechat_id: this.dataSet.wechat_id,
                        agent_id: this.dataSet.agent_id,
                        nickname: this.dataSet.nickname,
                        channel: this.dataSet.channel,
                        brand: this.dataSet.brand,
                        valid: this.dataSet.valid == 1 ? true : false,
                    })
                    .then(() => {
                        this.dataSet ={};
                        this.$message.success("提交成功");
                        this.showSetDomain = false;
                        this.loadData();
                    })
            },

            async loadData() {
                request.tools
                    .post("chat_room_get_list", {
                        range: [0, 2000]
                    })
                    .then(r => {
                        this.domainList = r.data.list;
                        this.loading = false;
                    });
            },
            showDiv () {
                this.room_disabled = false
                this.showSetDomain = true
                console.log(this.room_disabled);
            },

            handleUser: function(data) {
                this.showDiv();
                this.dataSet.chat_room = data.chat_room;
                this.dataSet.wechat_id = data.wechat_id;
                this.dataSet.agent_id = data.agent_id;
                this.dataSet.nickname = data.nickname;
                this.dataSet.channel = data.channel;
                this.dataSet.brand = data.brand;
                this.dataSet.valid = data.valid;
                this.room_disabled = true
            }

        }
    };
</script>